import React, { useState } from "react";
import { motion } from "framer-motion";

const News = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const items = [
    {
      id: 1,
      Text: "Зал уже как родной 🙂 Приветливый персонал, уютная атмосфера. В особенности рекомендую тренера по имени Злата...",
      Theme: "Абонемент на все",
      Image:
        "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=2970&auto=format&fit=crop",
    },
    {
      id: 2,
      Text: "Зал уже как родной 🙂 Приветливый персонал, уютная атмосфера. В особенности рекомендую тренера по имени Злата...",
      Theme: "Новый сервис к вашим услугам",
      Image:
        "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=2970&auto=format&fit=crop",
    },
    {
      id: 3,
      Text: "Зал уже как родной 🙂 Приветливый персонал, уютная атмосфера. В особенности рекомендую тренера по имени Злата...",
      Theme: "У нас теперь есть приватная зона",
      Image:
        "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?q=80&w=2970&auto=format&fit=crop",
    },
  ];

  return (
    <div className="bg-white min-h-screen flex flex-col">
      {/* Header / Title Section (shifted down with pt-16) */}
      <div className="text-center pt-16 px-4 mb-6">
        <h1 className="font-bold text-3xl sm:text-4xl">Новости</h1>
        <p className="text-lg sm:text-xl font-extralight mt-2">
          Актуальные новости про нас
        </p>
      </div>

      {/* Main Content Area 
          flex-1 => takes remaining space
          flex items-center justify-center => centers the grid vertically if there's only one row
      */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl w-full">
          {items.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-lg shadow-sm max-w-sm mx-auto w-full"
            >
              <div className="relative h-56 overflow-hidden rounded-t-lg">
                <img
                  src={item.Image}
                  alt="card-image"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4">
                <h6 className="mb-3 text-xl font-semibold text-slate-800">
                  {item.Theme}
                </h6>
                <button
                  className="rounded-md py-2 px-4 text-sm text-red-800 border-2 border-red-800 transition-all hover:bg-red-800 hover:text-white"
                  type="button"
                  onClick={() => setSelectedItem(item)}
                >
                  Read more
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Overlay */}
      {selectedItem && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-2"
          >
            <h2 className="text-2xl font-bold mb-4">{selectedItem.Theme}</h2>
            <img
              src={selectedItem.Image}
              alt="news"
              className="w-full h-56 object-cover rounded-md mb-4"
            />
            <p className="text-gray-700 mb-4">{selectedItem.Text}</p>
            <button
              className="mt-2 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-800"
              onClick={() => setSelectedItem(null)}
            >
              Close
            </button>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default News;
